import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import io from 'socket.io-client';
import { toastr } from 'react-redux-toastr';
import Store from '../../store';
import { addNewNotification } from "../../store/actions/network";
import { likePostSuccess, addPostViaSocket, deletePostViaSocket, sharePostViaSocket } from "../../store/actions/post";
import { postCommentSuccess, likeCommentSuccess } from "../../store/actions/comment";
import { addMsgViaSocket, openChatBox, addTypingThread, removeTypingThread } from "../../store/actions/messages";

function SocketHandlers() {
    const dispatch = useDispatch();
    const { userAuth } = Store.getState();
    const socket = io(process.env.SOCKET_ENDPOINT);


    useEffect(() => {
        // handlers on socket connection
        socket.on('connect', () => {
            const private_room = `private:room:${userAuth.userId}`;
            const public_room = "public:room";
            // join private room
            socket.emit('join:private:room', {
                private_room: private_room,
                user_id: userAuth.userId
            });
            // join public room
            socket.emit('join:public:room', {
                public_room: public_room,
                user_id: userAuth.userId
            });
        });
    }, []);

    // Online Users
    socket.on('onlineUsers', (message) => {
        // console.log("online users:", message);
    });

    // push notifications via socket
    socket.on('pushNotification', (message) => {
        if (message && Object.keys(message).length) {
            // Don't show current user notification if belongs to him.. We are also not saving these notifications to database as well..
            if (userAuth?.userId != message?.user?.id) {
                dispatch(addNewNotification(message));
            }
        }
        if (userAuth?.userId != message?.user?.id) {
            toastr.success(`${message?.user?.first_name} ${message?.user?.show_last_name && message?.user?.last_name} ${message?.message}`);
        }
    });

    // messages via socket
    socket.on('messageReceived', (message) => {
        let data = {
            chatId: message?.user?.id,
            msgReceived: true,
            message: {
                first_user_id: message?.user?.id,
                message: message?.message_text,
                second_user_id: message?.user_id,
                type: message?.type,
                created_at: new Date()
            }
        };
        if (userAuth?.userId != message?.user?.id) {
            let audio = new Audio("/chat/sounds/notification.mp3");
            audio.play();
        }
        if (message && Object.keys(message).length) {
            // if(window.innerWidth > 767) {
            //     dispatch(openChatBox({id: message?.user?.id}));
            // }
            dispatch(addMsgViaSocket(data));
        }
    });

    // socket event triggers and data handlers for notifications
    socket.on('postLiked', (message) => {
        let data = {};
        data.post_id = message?.post_id;
        data.liked_by_me = message?.user?.id === userAuth.userId ? 1 : 0;
        data.is_liked = true;
        dispatch(likePostSuccess(data));
    });
    socket.on('postLikedRemoved', (message) => {
        let data = {};
        data.post_id = message?.post_id;
        data.liked_by_me = message?.user?.id === userAuth.userId ? 1 : 0;
        data.is_liked = false;
        dispatch(likePostSuccess(data));
    });
    socket.on('postCommentAdded', (message) => {
        let data = {};
        data.post_id = message?.post_id;
        data.user = message?.user;
        data.comment = message?.comment;
        dispatch(postCommentSuccess(data));
    });
    socket.on('postShared', (message) => {
        let data = {};
        data.post = message?.post?.post;
        data.post.user = message?.user;
        data.post.likes_count = 0;
        data.post_media = Object.keys(message?.post?.post_media || {}).length ? [message?.post?.post_media[0]] : [];
        data.post_tags = message?.post?.post_tags;
        data.is_liked_by_me = 0;
        data.original_post_data = message?.post?.original_post_data;

        dispatch(addPostViaSocket(data));
    });
    socket.on('postCommentLiked', (message) => {
        let data = { post: {}, comment: {} };
        data.post.id = message?.post_id;
        data.comment.id = message?.comment_id;
        data.user_id = message?.user_id;
        // data.liked_by_me = message?.user?.id === userAuth.userId ? 1 : 0;
        data.is_liked = true;
        dispatch(likeCommentSuccess(data));
    });
    socket.on('postCommentLikeRemoved', (message) => {
        let data = { post: {}, comment: {} };
        data.post.id = message?.post_id;
        data.comment.id = message?.comment_id;
        data.user_id = message?.user?.id;
        // data.liked_by_me = message?.user?.id === userAuth.userId ? 1 : 0;
        data.is_liked = false;
        dispatch(likeCommentSuccess(data));
    });
    socket.on('postCreated', (message) => {
        let data = {};
        data.post = message?.post;
        data.post.user = message?.user;
        data.post.likes_count = 0;
        data.post_media = Object.keys(message?.post?.attachments || {}).length ? [message?.post?.attachments[0].url] : [];
        data.post_tags = message?.post?.tags;
        data.is_liked_by_me = 0;
        data.original_post_data = null;

        dispatch(addPostViaSocket(data));
    });
    socket.on('postUpdated', (message) => {
        let data = {};
        data.post = message?.post?.post;
        data.post.user = message?.user;
        data.post.likes_count = message?.post?.post?.likes_count;
        data.post_media = Object.keys(message?.post?.post_media || {}).length ? [message?.post?.post_media[0]] : [];
        data.post_tags = message?.post?.post_tags;
        // data.is_liked_by_me = 0;
        data.original_post_data = message?.post?.original_post_data;

        data.isUpdated = true;
        // data.post.user = message?.user;
        // data.is_liked_by_me = 0;

        dispatch(addPostViaSocket(data));
    });
    socket.on('postDeleted', (message) => {
        let data = {};
        data.post_id = message?.post_id;
        dispatch(deletePostViaSocket(data));
    });
    socket.on('userTyping', (message) => {
        dispatch(addTypingThread(message?.thread_id));
    });
    socket.on('userStoppedTypingMsg', (message) => {
        dispatch(removeTypingThread(message?.thread_id));
    });

    return (<></>);
};

export default SocketHandlers;
